// // src/components/Categories.jsx
// import React, { useState, useRef, useEffect } from 'react';
// import { MoreHorizontal, CirclePlus, Eye, Edit2, Trash2, EyeOff, Layers2 } from 'lucide-react';
// import CategoryModal from '../panelComponents/CategoriesComponent/CategoryModal';
// import SubCategoryModal from '../panelComponents/CategoriesComponent/SubCategoryModal';
// import { useCategories } from '../hooks/useCategories';

// // Add this component inside your Categories component or as a separate file
// const CategoriesSkeleton = () => {

//   return (
//     <div className="animate-pulse">
//       <div>
//         {/* Top Categories Skeleton with Wave Effect */}
//         <div className="mb-6">
//           <div className="h-10 bg-white border border-blue-200 rounded-lg w-36 mb-4"></div>
          
//           <div className="flex gap-8 overflow-hidden pb-2">
//             {[...Array(4)].map((_, index) => (
//               <div
//                 key={index}
//                 className="flex-shrink-0 px-6 py-4 rounded-lg bg-[#F1F5FF] flex items-center gap-3 relative overflow-hidden"
//               >
//                 {/* Wave effect overlay */}
//                 <div
//                   className="absolute inset-0 -translate-x-full animate-[wave_1.5s_ease-in-out_infinite]"
//                   style={{
//                     animationDelay: `${index * 0.2}s`,
//                     background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)'
//                   }}
//                 ></div>
                
//                 <div className="w-12 h-12 rounded-lg bg-blue-200"></div>
//                 <div className="h-4 bg-blue-100 rounded w-20"></div>
//                 <div className="w-4 h-4 rounded bg-blue-100 ml-2"></div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Sub Categories Section Skeleton */}
//         <div className="mb-6">
//           <div className="skeleton-shimmer h-10 w-36 rounded-lg bg-gray-200 mb-4"></div>
          
//           <div className="overflow-x-auto">
//             <table className="w-full border-separate border-spacing-y-2">
//               {/* Table Header Skeleton */}
//               <thead>
//                 <tr className="bg-blue-50 rounded-lg">
//                   <th className="px-4 py-3 rounded-l-lg">
//                     <div className="skeleton-shimmer h-4 w-16 rounded bg-gray-200"></div>
//                   </th>
//                   <th className="px-4 py-3">
//                     <div className="skeleton-shimmer h-4 w-16 rounded bg-gray-200"></div>
//                   </th>
//                   <th className="px-4 py-3 rounded-r-lg">
//                     <div className="skeleton-shimmer h-4 w-16 rounded bg-gray-200 ml-auto"></div>
//                   </th>
//                 </tr>
//               </thead>

//               {/* Table Body Skeleton */}
//               <tbody className="divide-y divide-transparent">
//                 {[...Array(5)].map((_, index) => (
//                   <tr
//                     key={index}
//                     className="bg-gray-50 rounded-xl shadow-sm border border-gray-200"
//                     style={{
//                       animationDelay: `${index * 0.1}s`
//                     }}
//                   >
//                     <td className="px-4 py-3 rounded-l-xl">
//                       <div className="flex items-center gap-3">
//                         <div className="skeleton-shimmer h-4 w-24 rounded bg-gray-200"></div>
//                         <div className="skeleton-shimmer h-4 w-12 rounded-full bg-gray-200"></div>
//                       </div>
//                     </td>
//                     <td className="px-4 py-3">
//                       <div className="skeleton-shimmer w-10 h-10 rounded bg-gray-200"></div>
//                     </td>
//                     <td className="px-4 py-3 rounded-r-xl">
//                       <div className="skeleton-shimmer w-5 h-5 rounded bg-gray-200 ml-auto"></div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const Categories = () => {
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [showCategoryModal, setShowCategoryModal] = useState(false);
//   const [showSubCategoryModal, setShowSubCategoryModal] = useState(false);
//   const [editingCategory, setEditingCategory] = useState(null);
//   const [editingSubCategory, setEditingSubCategory] = useState(null);
//   const [menuIndex, setMenuIndex] = useState(null);
//   const scrollContainerRef = useRef(null);
//   const dropdownRef = useRef(null);
//   // const [isLoading, setIsLoading] = useState(true);

// const {
//     topCategories,
//     subCategories,
//     loading,
//     error,
//     addTopCategory,
//     addSubCategory,
//     updateTopCategory,
//     updateSubCategory,
//     deleteTopCategory,
//     deleteSubCategory,
//     toggleSubCategoryVisibility,
//     // toggleTopCategoryVisibility,
//     refetch
// } = useCategories();

//     useEffect(() => {
//     if (topCategories && subCategories) {
//       // setIsLoading(false);
//     }
//   }, [topCategories, subCategories]);

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !event.target.closest('button')) {
//         setMenuIndex(null);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   const filteredSubCategories = selectedCategory
//     ? subCategories.filter(sub => 
//         (sub.categoryId === selectedCategory.id || sub.categoryId === selectedCategory._id) ||
//         (sub.topCategoryId === selectedCategory.id || sub.topCategoryId === selectedCategory._id)
//       )
//     : subCategories;

//   const handleCategoryEdit = (category) => {
//     setEditingCategory(category);
//     setShowCategoryModal(true);
//     setMenuIndex(null);
//   };

//   const handleSubCategoryEdit = (subCategory) => {
//     setEditingSubCategory(subCategory);
//     setShowSubCategoryModal(true);
//     setMenuIndex(null);
//   };

//   const handleDeleteCategory = (id) => {
//     if (window.confirm('Are you sure you want to delete this category?')) {
//       deleteTopCategory(id);
//     }
//   };

//   const handleDeleteSubCategory = (id) => {
//     if (window.confirm('Are you sure you want to delete this sub-category?')) {
//       deleteSubCategory(id);
//       setMenuIndex(null);
//     }
//   };

//   const handleView = (subCategory) => {
//     console.log('Viewing:', subCategory);
//     setMenuIndex(null);
//     // Implement view logic here
//   };

//   const handleToggleVisibility = (id) => {
//     toggleSubCategoryVisibility(id);
//     setMenuIndex(null);
//   };
//   if (error) {
//     return (
//       <div className="text-center py-16">
//         <div className="text-red-600 mb-4">
//           <h3 className="text-lg font-semibold">Error loading categories</h3>
//           <p className="text-sm">{error}</p>
//         </div>
//         <button 
//           onClick={refetch} 
//           className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
//         >
//           Try Again
//         </button>
//       </div>
//     );
//   }
//   return (
//     <div>
//       <div>
//         {/* Header */}
//         <div className="mb-6">
//           <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
//             <h1 className="text-2xl font-bold text-gray-900">Categories</h1>
//             <div className="flex gap-3 flex-wrap">
//               <button
//                 onClick={() => {
//                   setEditingCategory(null);
//                   setShowCategoryModal(true);
//                 }}
//                 className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 
//                          transition-colors flex items-center gap-2 text-sm md:text-base"
//               >
//                 <span className="text-lg"><CirclePlus/></span>
//                 Add Categories
//               </button>
//               <button
//                 onClick={() => {
//                   setEditingSubCategory(null);
//                   setShowSubCategoryModal(true);
//                 }}
//                 className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 
//                          transition-colors flex items-center gap-2 text-sm md:text-base"
//               >
//                 <span className="text-lg"><CirclePlus/></span>
//                 Sub Categories
//               </button>
//             </div>
//           </div>
//         </div>
        
//         { loading ? <CategoriesSkeleton /> :  <>
//             {/* Top Categories Section */}
//             <div className="mb-6">
//             <div className="flex items-center justify-between mb-4">
//                 <h2 className="text-lg font-semibold text-gray-900 mb-4 border border-blue-200 bg-white rounded-lg px-4 py-2 inline-block">
//                 Top Categories
//                 </h2>
//             </div>

//             {/* Horizontal Scrollable Categories */}
//             <div className="relative">
//             <div
//                 ref={scrollContainerRef}
//                 className="flex gap-8 overflow-x-auto scrollbar-hide pb-2"
//                 style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
//             >
//                 {topCategories.map((category, index) => (
//                 <div
//                     key={category._id}
//                     onClick={() => setSelectedCategory(category)}
//                     className={`flex-shrink-0 px-6 py-4 rounded-lg shadow-md cursor-pointer transition-all relative group flex items-center gap-3
//                             ${selectedCategory?.id === category.id 
//                             ? 'bg-[#F1F5FF] border-2 border-blue-300' 
//                             : 'bg-[#F1F5FF] border-2 border-transparent hover:bg-blue-100'}`}
//                 >
//                     {/* Image */}
//                     <div className="relative ">
//                     <img
//                         src={category.image}
//                         alt={category.name}
//                         className={`w-12 h-12 object-cover rounded-lg shadow-lg transition-opacity ${category.hidden ? 'opacity-50' : ''}`}
//                     />
//                     {category.hidden && (
//                         <div className="absolute inset-0 flex items-center justify-center bg-white/50 rounded-lg">
//                         <EyeOff className="w-5 h-5 text-gray-600" />
//                         </div>
//                     )}
//                     </div>
                    
//                     {/* Name */}
//                     <span className={`text-sm font-medium pr-2 ${category.hidden ? 'opacity-50' : ''}`}>
//                     {category.name}
//                     </span>

//                     {/* Dropdown Menu Button - Always visible */}
//                     <div className="ml-auto">
//                     <button
//                         onClick={(e) => {
//                         e.stopPropagation();
//                         const button = e.currentTarget;
//                         const buttonRect = button.getBoundingClientRect();
                        
//                         setMenuIndex(menuIndex === `cat-${index}` ? null : {
//                             index: `cat-${index}`,
//                             position: {
//                             top: buttonRect.bottom + window.scrollY,
//                             left: buttonRect.left,
//                             direction: window.innerHeight - buttonRect.bottom > 150 ? 'below' : 'above'
//                             }
//                         });
//                         }}
//                         className="p-1 hover:bg-blue-200 rounded transition-colors"
//                     >
//                         <MoreHorizontal className="w-4 h-4 text-gray-600" />
//                     </button>

//                     {/* Dropdown Menu */}
//                     {menuIndex?.index === `cat-${index}` && (
//                         <div
//                         ref={dropdownRef}
//                         className="fixed z-50 w-40 bg-white shadow-lg rounded-lg border border-gray-200 py-1"
//                         style={{
//                             top: menuIndex.position.direction === 'below'
//                             ? `${menuIndex.position.top + 5}px`
//                             : `${menuIndex.position.top - 100}px`,
//                             left: `${menuIndex.position.left - 120}px`
//                         }}
//                         >
//                         <button
//                             onClick={() => {
//                             handleCategoryEdit(category);
//                             setMenuIndex(null);
//                             }}
//                             className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
//                         >
//                             <Edit2 size={16} /> Edit
//                         </button>
//                         <div className="border-t border-gray-100 my-1"></div>
//                         <button
//                             onClick={() => {
//                             handleDeleteCategory(category.id);
//                             setMenuIndex(null);
//                             }}
//                             className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
//                         >
//                             <Trash2 size={16} /> Delete
//                         </button>
//                         </div>
//                     )}
//                     </div>
//                 </div>
//                 ))}
//             </div>
//             </div>
//             </div>

//             {/* Sub Categories Section */}
//             <div className="mb-6">
//             <h2 className="text-lg font-semibold text-gray-900 mb-4 border border-blue-200 bg-white rounded-lg px-4 py-2 inline-block">
//             Sub Categories
//             </h2>
            
//             <div className="overflow-x-auto">
//                 <table className="w-full border-separate border-spacing-y-2 shadow rounded">
//                 <thead>
//                     <tr className="bg-blue-50 text-left rounded-lg">
//                     <th className="px-4 py-3 text-sm font-medium text-gray-700 rounded-l-lg">Name</th>
//                     <th className="px-4 py-3 text-sm font-medium text-gray-700">Image</th>
//                     <th className="px-4 py-3 text-sm font-medium text-gray-700 text-right rounded-r-lg">Actions</th>
//                     </tr>
//                 </thead>
//                 <tbody className="divide-y divide-transparent">
//                     {filteredSubCategories.map((subCategory, index) => (
//                     <tr key={subCategory._id} className="bg-gray-50 rounded-xl shadow-sm border border-gray-200 hover:bg-gray-100 transition-colors">
//                         <td className="px-4 py-3 rounded-l-xl">
//                         <div className="flex items-center gap-3">
//                             <span className="text-sm font-medium text-gray-900">{subCategory.name}</span>
//                             {subCategory.status === 'deleted' && (
//                             <span className="px-2 py-1 bg-red-100 text-red-600 text-xs rounded-full">
//                                 Deleted
//                             </span>
//                             )}
//                             {subCategory.hidden && (
//                             <EyeOff className="w-4 h-4 text-gray-400" />
//                             )}
//                         </div>
//                         </td>
//                         <td className="px-4 py-3">
//                         <div className="flex">
//                             <img
//                             src={subCategory.image}
//                             alt={subCategory.name}
//                             className="w-10 h-10 object-cover rounded"
//                             />
//                         </div>
//                         </td>
//                         <td className="px-4 py-3 rounded-r-xl">
//                         <div className="flex items-center justify-end">
//                             <div className="relative">
//                             <button
//                                 onClick={(e) => {
//                                 e.stopPropagation();
//                                 const button = e.currentTarget;
//                                 const buttonRect = button.getBoundingClientRect();
                                
//                                 setMenuIndex(menuIndex === index ? null : {
//                                     index,
//                                     position: {
//                                     top: buttonRect.bottom + window.scrollY,
//                                     left: buttonRect.right - 144,
//                                     direction: window.innerHeight - buttonRect.bottom > 200 ? 'below' : 'above'
//                                     }
//                                 });
//                                 }}
//                                 className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
//                             >
//                                 <MoreHorizontal className="w-5 h-5 text-gray-500" />
//                             </button>

//                             {menuIndex?.index === index && (
//                                 <div
//                                 ref={dropdownRef}
//                                 className="fixed z-50 w-40 bg-white shadow-lg rounded-lg border border-gray-200 py-1"
//                                 style={{
//                                     top: menuIndex.position.direction === 'below'
//                                     ? `${menuIndex.position.top + 5}px`
//                                     : `${menuIndex.position.top - 165}px`,
//                                     left: `${menuIndex.position.left}px`
//                                 }}
//                                 >
//                                 <button
//                                     onClick={() => handleView(subCategory)}
//                                     className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
//                                 >
//                                     <Eye size={16} /> View
//                                 </button>
//                                 <button
//                                     onClick={() => handleSubCategoryEdit(subCategory)}
//                                     className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
//                                 >
//                                     <Edit2 size={16} /> Edit
//                                 </button>
//                                 <button
//                                     onClick={() => handleToggleVisibility(subCategory._id)}
//                                     className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
//                                 >
//                                     <EyeOff size={16} /> {subCategory.hidden ? 'Show' : 'Hide'}
//                                 </button>
//                                 <div className="border-t border-gray-100 my-1"></div>
//                                 <button
//                                     onClick={() => handleDeleteSubCategory(subCategory.id)}
//                                     className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
//                                 >
//                                     <Trash2 size={16} /> Delete
//                                 </button>
//                                 </div>
//                             )}
//                             </div>
//                         </div>
//                         </td>
//                     </tr>
//                     ))}
//                 </tbody>
//                 </table>
//                 {filteredSubCategories.length === 0 && (
//                 <div className="flex flex-col items-center justify-center py-16 px-4">
//                     {/* Icon Container */}
//                     <div className="relative mb-6">
//                     <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center">
//                         <Layers2 className="w-12 h-12 text-gray-400" />
//                     </div>
//                     {/* Decorative dots */}
//                     <div className="absolute -top-2 -right-2 w-6 h-6 bg-blue-100 rounded-full"></div>
//                     <div className="absolute -bottom-1 -left-1 w-4 h-4 bg-blue-200 rounded-full"></div>
//                     <div className="absolute top-8 -right-6 w-3 h-3 bg-gray-200 rounded-full"></div>
//                     </div>

//                     {/* Message */}
//                     <h3 className="text-lg font-semibold text-gray-900 mb-2">
//                     No Sub-Categories Yet
//                     </h3>
//                     <p className="text-sm text-gray-500 text-center max-w-md mb-6">
//                     {selectedCategory 
//                         ? `Start by adding sub-categories to "${selectedCategory.name}" to organize your products better.`
//                         : "Select a category above or create sub-categories to organize your products."}
//                     </p>

//                     {/* Action Button */}
//                     <button
//                     onClick={() => {
//                         setEditingSubCategory(null);
//                         setShowSubCategoryModal(true);
//                     }}
//                     className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 
//                             transition-colors flex items-center gap-2 text-sm"
//                     >
//                     <svg 
//                         className="w-4 h-4" 
//                         fill="none" 
//                         viewBox="0 0 24 24" 
//                         stroke="currentColor"
//                     >
//                         <path 
//                         strokeLinecap="round" 
//                         strokeLinejoin="round" 
//                         strokeWidth={2} 
//                         d="M12 4v16m8-8H4" 
//                         />
//                     </svg>
//                     Add First Sub-Category
//                     </button>
//                 </div>
//                 )}
//             </div>
//             </div>
//         </>}

//         {/* Modals */}
//         <CategoryModal
//           isOpen={showCategoryModal}
//           onClose={() => {
//             setShowCategoryModal(false);
//             setEditingCategory(null);
//           }}
//           onSubmit={(data) => {
//             if (editingCategory) {
//               updateTopCategory(editingCategory._id, data);
//             } else {
//               addTopCategory(data);
//             }
//             setShowCategoryModal(false);
//             setEditingCategory(null);
//           }}
//           editingCategory={editingCategory}
//         />

//         <SubCategoryModal
//           isOpen={showSubCategoryModal}
//           onClose={() => {
//             setShowSubCategoryModal(false);
//             setEditingSubCategory(null);
//           }}
//           onSubmit={(data) => {
//             if (editingSubCategory) {
//               updateSubCategory(editingSubCategory._id, data);
//             } else {
//               addSubCategory(data);
//             }
//             setShowSubCategoryModal(false);
//             setEditingSubCategory(null);
//           }}
//           editingSubCategory={editingSubCategory}
//           topCategories={topCategories}
//         />
//       </div>
//     </div>
//   );
// };

// export default Categories;

// import React, { useState, useRef, useEffect } from 'react';
// import { MoreHorizontal, CirclePlus, Eye, Edit2, Trash2, EyeOff, Layers2, X } from 'lucide-react';
// import CategoryModal from '../panelComponents/CategoriesComponent/CategoryModal';
// import SubCategoryModal from '../panelComponents/CategoriesComponent/SubCategoryModal';
// import { useCategories } from '../hooks/useCategories';

// // Categories Skeleton Component
// const CategoriesSkeleton = () => {
//   return (
//     <div className="animate-pulse">
//       <div>
//         {/* Top Categories Skeleton with Wave Effect */}
//         <div className="mb-6">
//           <div className="h-10 bg-white border border-blue-200 rounded-lg w-36 mb-4"></div>
          
//           <div className="flex gap-8 overflow-hidden pb-2">
//             {[...Array(4)].map((_, index) => (
//               <div
//                 key={index}
//                 className="flex-shrink-0 px-6 py-4 rounded-lg bg-[#F1F5FF] flex items-center gap-3 relative overflow-hidden"
//               >
//                 {/* Wave effect overlay */}
//                 <div
//                   className="absolute inset-0 -translate-x-full animate-[wave_1.5s_ease-in-out_infinite]"
//                   style={{
//                     animationDelay: `${index * 0.2}s`,
//                     background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)'
//                   }}
//                 ></div>
                
//                 <div className="w-12 h-12 rounded-lg bg-blue-200"></div>
//                 <div className="h-4 bg-blue-100 rounded w-20"></div>
//                 <div className="w-4 h-4 rounded bg-blue-100 ml-2"></div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Sub Categories Section Skeleton */}
//         <div className="mb-6">
//           <div className="skeleton-shimmer h-10 w-36 rounded-lg bg-gray-200 mb-4"></div>
          
//           <div className="overflow-x-auto">
//             <table className="w-full border-separate border-spacing-y-2">
//               {/* Table Header Skeleton */}
//               <thead>
//                 <tr className="bg-blue-50 rounded-lg">
//                   <th className="px-4 py-3 rounded-l-lg">
//                     <div className="skeleton-shimmer h-4 w-16 rounded bg-gray-200"></div>
//                   </th>
//                   <th className="px-4 py-3">
//                     <div className="skeleton-shimmer h-4 w-16 rounded bg-gray-200"></div>
//                   </th>
//                   <th className="px-4 py-3 rounded-r-lg">
//                     <div className="skeleton-shimmer h-4 w-16 rounded bg-gray-200 ml-auto"></div>
//                   </th>
//                 </tr>
//               </thead>

//               {/* Table Body Skeleton */}
//               <tbody className="divide-y divide-transparent">
//                 {[...Array(5)].map((_, index) => (
//                   <tr
//                     key={index}
//                     className="bg-gray-50 rounded-xl shadow-sm border border-gray-200"
//                     style={{
//                       animationDelay: `${index * 0.1}s`
//                     }}
//                   >
//                     <td className="px-4 py-3 rounded-l-xl">
//                       <div className="flex items-center gap-3">
//                         <div className="skeleton-shimmer h-4 w-24 rounded bg-gray-200"></div>
//                         <div className="skeleton-shimmer h-4 w-12 rounded-full bg-gray-200"></div>
//                       </div>
//                     </td>
//                     <td className="px-4 py-3">
//                       <div className="skeleton-shimmer w-10 h-10 rounded bg-gray-200"></div>
//                     </td>
//                     <td className="px-4 py-3 rounded-r-xl">
//                       <div className="skeleton-shimmer w-5 h-5 rounded bg-gray-200 ml-auto"></div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const Categories = () => {
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [showCategoryModal, setShowCategoryModal] = useState(false);
//   const [showSubCategoryModal, setShowSubCategoryModal] = useState(false);
//   const [editingCategory, setEditingCategory] = useState(null);
//   const [editingSubCategory, setEditingSubCategory] = useState(null);
//   const [menuIndex, setMenuIndex] = useState(null);
//   const scrollContainerRef = useRef(null);
//   const dropdownRef = useRef(null);

//   const {
//     topCategories,
//     subCategories,
//     loading,
//     error,
//     addTopCategory,
//     addSubCategory,
//     updateTopCategory,
//     updateSubCategory,
//     deleteTopCategory,
//     deleteSubCategory,
//     toggleSubCategoryVisibility,
//     refetch
//   } = useCategories();

//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !event.target.closest('button')) {
//         setMenuIndex(null);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   // Fixed filtering logic with more robust matching
//   const filteredSubCategories = selectedCategory
//     ? subCategories.filter(sub => {
//         // Get all possible category IDs
//         const selectedCategoryId = selectedCategory._id || selectedCategory.id;
        
//         // Check all possible field names where the parent category ID might be stored
//         const possibleParentIds = [
//           sub.categoryId,
//           sub.topCategory?._id,
//           sub.topCategory?.id, 
//           sub.topCategory,
//           sub.parentCategoryId,
//           sub.topCategoryId,
//           sub.category?._id,
//           sub.category?.id,
//           sub.category
//         ].filter(Boolean); // Remove null/undefined values

//         // Check if any of the possible parent IDs match the selected category ID
//         return possibleParentIds.some(parentId => {
//           // Handle both string and object comparisons
//           if (typeof parentId === 'object') {
//             return parentId._id === selectedCategoryId || parentId.id === selectedCategoryId;
//           }
//           return parentId === selectedCategoryId;
//         });
//       })
//     : subCategories; // Show ALL sub-categories when no category is selected

//   // Get selected category name for display
//   const selectedCategoryName = selectedCategory?.name || null;

//   const handleCategorySelect = (category) => {
//     // Toggle selection - if same category clicked, deselect it
//     if (selectedCategory && (selectedCategory._id === category._id || selectedCategory.id === category.id)) {
//       setSelectedCategory(null);
//     } else {
//       setSelectedCategory(category);
//     }
//   };

//   const handleClearFilter = () => {
//     setSelectedCategory(null);
//   };

//   const handleCategoryEdit = (category) => {
//     setEditingCategory(category);
//     setShowCategoryModal(true);
//     setMenuIndex(null);
//   };

//   const handleSubCategoryEdit = (subCategory) => {
//     setEditingSubCategory(subCategory);
//     setShowSubCategoryModal(true);
//     setMenuIndex(null);
//   };

//   const handleDeleteCategory = (id) => {
//     if (window.confirm('Are you sure you want to delete this category?')) {
//       deleteTopCategory(id);
//       setMenuIndex(null);
//       // Clear selection if deleted category was selected
//       if (selectedCategory && (selectedCategory._id === id || selectedCategory.id === id)) {
//         setSelectedCategory(null);
//       }
//     }
//   };

//   const handleDeleteSubCategory = (id) => {
//     if (window.confirm('Are you sure you want to delete this sub-category?')) {
//       deleteSubCategory(id);
//       setMenuIndex(null);
//     }
//   };

//   const handleView = (subCategory) => {
//     console.log('Viewing:', subCategory);
//     setMenuIndex(null);
//     // Implement view logic here
//   };

//   const handleToggleVisibility = (id) => {
//     toggleSubCategoryVisibility(id);
//     setMenuIndex(null);
//   };

//   if (error) {
//     return (
//       <div className="text-center py-16">
//         <div className="text-red-600 mb-4">
//           <h3 className="text-lg font-semibold">Error loading categories</h3>
//           <p className="text-sm">{error}</p>
//         </div>
//         <button 
//           onClick={refetch} 
//           className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
//         >
//           Try Again
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <div>
//         {/* Header */}
//         <div className="mb-6">
//           <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
//             <h1 className="text-2xl font-bold text-gray-900">Categories</h1>
//             <div className="flex gap-3 flex-wrap">
//               <button
//                 onClick={() => {
//                   setEditingCategory(null);
//                   setShowCategoryModal(true);
//                 }}
//                 className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 
//                          transition-colors flex items-center gap-2 text-sm md:text-base"
//               >
//                 <CirclePlus size={18} />
//                 Add Categories
//               </button>
//               <button
//                 onClick={() => {
//                   setEditingSubCategory(null);
//                   setShowSubCategoryModal(true);
//                 }}
//                 className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 
//                          transition-colors flex items-center gap-2 text-sm md:text-base"
//               >
//                 <CirclePlus size={18} />
//                 Sub Categories
//               </button>
//             </div>
//           </div>
//         </div>
        
//         {loading ? <CategoriesSkeleton /> : <>
//           {/* Top Categories Section */}
//           <div className="mb-6">
//             <div className="flex items-center justify-between mb-4">
//               <h2 className="text-lg font-semibold text-gray-900 mb-4 border border-blue-200 bg-white rounded-lg px-4 py-2 inline-block">
//                 Top Categories ({topCategories.length})
//               </h2>
//             </div>

//             {/* Horizontal Scrollable Categories */}
//             <div className="relative">
//               <div
//                 ref={scrollContainerRef}
//                 className="flex gap-8 overflow-x-auto scrollbar-hide pb-2"
//                 style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
//               >
//                 {topCategories.map((category, index) => (
//                   <div
//                     key={category._id || category.id}
//                     onClick={() => handleCategorySelect(category)}
//                     className={`flex-shrink-0 px-6 py-4 rounded-lg shadow-md cursor-pointer transition-all relative group flex items-center gap-3
//                             ${selectedCategory && (selectedCategory._id === category._id || selectedCategory.id === category.id)
//                               ? 'bg-blue-500 text-white border-2 border-blue-600' 
//                               : 'bg-[#F1F5FF] border-2 border-transparent hover:bg-blue-100'}`}
//                   >
//                     {/* Image */}
//                     <div className="relative">
//                       <img
//                         src={category.image}
//                         alt={category.name}
//                         className={`w-12 h-12 object-cover rounded-lg shadow-lg transition-opacity ${category.hidden ? 'opacity-50' : ''}`}
//                       />
//                       {category.hidden && (
//                         <div className="absolute inset-0 flex items-center justify-center bg-white/50 rounded-lg">
//                           <EyeOff className="w-5 h-5 text-gray-600" />
//                         </div>
//                       )}
//                     </div>
                    
//                     {/* Name */}
//                     <span className={`text-sm font-medium pr-2 ${category.hidden ? 'opacity-50' : ''}`}>
//                       {category.name}
//                     </span>

//                     {/* Dropdown Menu Button */}
//                     <div className="ml-auto">
//                       <button
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           const button = e.currentTarget;
//                           const buttonRect = button.getBoundingClientRect();
                          
//                           setMenuIndex(menuIndex === `cat-${index}` ? null : {
//                             index: `cat-${index}`,
//                             position: {
//                               top: buttonRect.bottom + window.scrollY,
//                               left: buttonRect.left,
//                               direction: window.innerHeight - buttonRect.bottom > 150 ? 'below' : 'above'
//                             }
//                           });
//                         }}
//                         className={`p-1 rounded transition-colors ${
//                           selectedCategory && (selectedCategory._id === category._id || selectedCategory.id === category.id)
//                             ? 'hover:bg-blue-600 text-white' 
//                             : 'hover:bg-blue-200 text-gray-600'
//                         }`}
//                       >
//                         <MoreHorizontal className="w-4 h-4" />
//                       </button>

//                       {/* Dropdown Menu */}
//                       {menuIndex?.index === `cat-${index}` && (
//                         <div
//                           ref={dropdownRef}
//                           className="fixed z-50 w-40 bg-white shadow-lg rounded-lg border border-gray-200 py-1"
//                           style={{
//                             top: menuIndex.position.direction === 'below'
//                               ? `${menuIndex.position.top + 5}px`
//                               : `${menuIndex.position.top - 100}px`,
//                             left: `${menuIndex.position.left - 120}px`
//                           }}
//                         >
//                           <button
//                             onClick={() => handleCategoryEdit(category)}
//                             className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
//                           >
//                             <Edit2 size={16} /> Edit
//                           </button>
//                           <div className="border-t border-gray-100 my-1"></div>
//                           <button
//                             onClick={() => handleDeleteCategory(category._id || category.id)}
//                             className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
//                           >
//                             <Trash2 size={16} /> Delete
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* Sub Categories Section */}
//           <div className="mb-6">
//             <div className="flex items-center justify-between mb-4">
//               <h2 className="text-lg font-semibold text-gray-900 border border-blue-200 bg-white rounded-lg px-4 py-2 inline-block">
//                 Sub Categories ({filteredSubCategories.length})
//                 {selectedCategoryName && (
//                   <span className="text-sm font-normal text-blue-600 ml-2">
//                     - {selectedCategoryName}
//                   </span>
//                 )}
//               </h2>
              
//               {/* Clear Filter Button */}
//               {selectedCategory && (
//                 <button
//                   onClick={handleClearFilter}
//                   className="px-3 py-2 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg flex items-center gap-2 transition-colors"
//                 >
//                   <X size={16} />
//                   Show All ({subCategories.length})
//                 </button>
//               )}
//             </div>
            
//             <div className="overflow-x-auto">
//               <table className="w-full border-separate border-spacing-y-2 shadow rounded">
//                 <thead>
//                   <tr className="bg-blue-50 text-left rounded-lg">
//                     <th className="px-4 py-3 text-sm font-medium text-gray-700 rounded-l-lg">Name</th>
//                     <th className="px-4 py-3 text-sm font-medium text-gray-700">Image</th>
//                     <th className="px-4 py-3 text-sm font-medium text-gray-700">Category</th>
//                     <th className="px-4 py-3 text-sm font-medium text-gray-700 text-right rounded-r-lg">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-transparent">
//                   {filteredSubCategories.map((subCategory, index) => {
//                     // Find parent category name with improved matching
//                     const parentCategory = topCategories.find(cat => {
//                       const categoryId = cat._id || cat.id;
//                       const possibleParentIds = [
//                         subCategory.categoryId,
//                         subCategory.topCategory?._id,
//                         subCategory.topCategory?.id, 
//                         subCategory.topCategory,
//                         subCategory.parentCategoryId,
//                         subCategory.topCategoryId,
//                         subCategory.category?._id,
//                         subCategory.category?.id,
//                         subCategory.category
//                       ].filter(Boolean);

//                       return possibleParentIds.some(parentId => {
//                         if (typeof parentId === 'object') {
//                           return parentId._id === categoryId || parentId.id === categoryId;
//                         }
//                         return parentId === categoryId;
//                       });
//                     });

//                     return (
//                       <tr key={subCategory._id || subCategory.id} className="bg-gray-50 rounded-xl shadow-sm border border-gray-200 hover:bg-gray-100 transition-colors">
//                         <td className="px-4 py-3 rounded-l-xl">
//                           <div className="flex items-center gap-3">
//                             <span className="text-sm font-medium text-gray-900">{subCategory.name}</span>
//                             {subCategory.status === 'deleted' && (
//                               <span className="px-2 py-1 bg-red-100 text-red-600 text-xs rounded-full">
//                                 Deleted
//                               </span>
//                             )}
//                             {subCategory.hidden && (
//                               <EyeOff className="w-4 h-4 text-gray-400" />
//                             )}
//                           </div>
//                         </td>
//                         <td className="px-4 py-3">
//                           <div className="flex">
//                             <img
//                               src={subCategory.image}
//                               alt={subCategory.name}
//                               className="w-10 h-10 object-cover rounded"
//                             />
//                           </div>
//                         </td>
//                         <td className="px-4 py-3">
//                           <span className="text-xs px-2 py-1 bg-blue-100 text-blue-800 rounded-full">
//                             {parentCategory?.name || 'Unknown'}
//                           </span>
//                         </td>
//                         <td className="px-4 py-3 rounded-r-xl">
//                           <div className="flex items-center justify-end">
//                             <div className="relative">
//                               <button
//                                 onClick={(e) => {
//                                   e.stopPropagation();
//                                   const button = e.currentTarget;
//                                   const buttonRect = button.getBoundingClientRect();
                                  
//                                   setMenuIndex(menuIndex === `sub-${index}` ? null : {
//                                     index: `sub-${index}`,
//                                     position: {
//                                       top: buttonRect.bottom + window.scrollY,
//                                       left: buttonRect.right - 144,
//                                       direction: window.innerHeight - buttonRect.bottom > 200 ? 'below' : 'above'
//                                     }
//                                   });
//                                 }}
//                                 className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
//                               >
//                                 <MoreHorizontal className="w-5 h-5 text-gray-500" />
//                               </button>

//                               {menuIndex?.index === `sub-${index}` && (
//                                 <div
//                                   ref={dropdownRef}
//                                   className="fixed z-50 w-40 bg-white shadow-lg rounded-lg border border-gray-200 py-1"
//                                   style={{
//                                     top: menuIndex.position.direction === 'below'
//                                       ? `${menuIndex.position.top + 5}px`
//                                       : `${menuIndex.position.top - 165}px`,
//                                     left: `${menuIndex.position.left}px`
//                                   }}
//                                 >
//                                   <button
//                                     onClick={() => handleView(subCategory)}
//                                     className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
//                                   >
//                                     <Eye size={16} /> View
//                                   </button>
//                                   <button
//                                     onClick={() => handleSubCategoryEdit(subCategory)}
//                                     className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
//                                   >
//                                     <Edit2 size={16} /> Edit
//                                   </button>
//                                   <button
//                                     onClick={() => handleToggleVisibility(subCategory._id || subCategory.id)}
//                                     className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
//                                   >
//                                     <EyeOff size={16} /> {subCategory.hidden ? 'Show' : 'Hide'}
//                                   </button>
//                                   <div className="border-t border-gray-100 my-1"></div>
//                                   <button
//                                     onClick={() => handleDeleteSubCategory(subCategory._id || subCategory.id)}
//                                     className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
//                                   >
//                                     <Trash2 size={16} /> Delete
//                                   </button>
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
              
//               {/* No Data Message */}
//               {filteredSubCategories.length === 0 && (
//                 <div className="flex flex-col items-center justify-center py-16 px-4">
//                   {/* Icon Container */}
//                   <div className="relative mb-6">
//                     <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center">
//                       <Layers2 className="w-12 h-12 text-gray-400" />
//                     </div>
//                     {/* Decorative dots */}
//                     <div className="absolute -top-2 -right-2 w-6 h-6 bg-blue-100 rounded-full"></div>
//                     <div className="absolute -bottom-1 -left-1 w-4 h-4 bg-blue-200 rounded-full"></div>
//                     <div className="absolute top-8 -right-6 w-3 h-3 bg-gray-200 rounded-full"></div>
//                   </div>

//                   {/* Message */}
//                   <h3 className="text-lg font-semibold text-gray-900 mb-2">
//                     {selectedCategory ? 'No Sub-Categories in this Category' : 'No Sub-Categories Yet'}
//                   </h3>
//                   <p className="text-sm text-gray-500 text-center max-w-md mb-6">
//                     {selectedCategory 
//                       ? `No sub-categories found for "${selectedCategory.name}". Add some to organize your products better.`
//                       : "Start by adding sub-categories to organize your products better."}
//                   </p>

//                   {/* Action Buttons */}
//                   <div className="flex gap-3">
//                     {selectedCategory && (
//                       <button
//                         onClick={handleClearFilter}
//                         className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 
//                                 transition-colors flex items-center gap-2 text-sm"
//                       >
//                         <Eye className="w-4 h-4" />
//                         Show All Sub-Categories
//                       </button>
//                     )}
//                     <button
//                       onClick={() => {
//                         setEditingSubCategory(null);
//                         setShowSubCategoryModal(true);
//                       }}
//                       className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 
//                               transition-colors flex items-center gap-2 text-sm"
//                     >
//                       <CirclePlus className="w-4 h-4" />
//                       {selectedCategory ? 'Add Sub-Category' : 'Add First Sub-Category'}
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </>}

//         {/* Modals */}
//         <CategoryModal
//           isOpen={showCategoryModal}
//           onClose={() => {
//             setShowCategoryModal(false);
//             setEditingCategory(null);
//           }}
//           onSubmit={(data) => {
//             if (editingCategory) {
//               updateTopCategory(editingCategory._id || editingCategory.id, data);
//             } else {
//               addTopCategory(data);
//             }
//             setShowCategoryModal(false);
//             setEditingCategory(null);
//           }}
//           editingCategory={editingCategory}
//         />

//         <SubCategoryModal
//           isOpen={showSubCategoryModal}
//           onClose={() => {
//             setShowSubCategoryModal(false);
//             setEditingSubCategory(null);
//           }}
//           onSubmit={(data) => {
//             if (editingSubCategory) {
//               updateSubCategory(editingSubCategory._id || editingSubCategory.id, data);
//             } else {
//               addSubCategory(data);
//             }
//             setShowSubCategoryModal(false);
//             setEditingSubCategory(null);
//           }}
//           editingSubCategory={editingSubCategory}
//           topCategories={topCategories}
//         />
//       </div>
//     </div>
//   );
// };

// export default Categories;
import React, { useState, useRef, useEffect } from 'react';
import { MoreHorizontal, CirclePlus, Eye, Edit2, Trash2, EyeOff, Layers2, X } from 'lucide-react';
import CategoryModal from '../panelComponents/CategoriesComponent/CategoryModal';
import SubCategoryModal from '../panelComponents/CategoriesComponent/SubCategoryModal';
import { useCategories } from '../hooks/useCategories';

const CategoriesSkeleton = () => {
  return (
    <div className="animate-pulse">
      <div>
        {/* Top Categories Skeleton with Wave Effect */}
        <div className="mb-6">
          <div className="h-10 bg-white border border-blue-200 rounded-lg w-36 mb-4"></div>
          
          <div className="flex gap-8 overflow-hidden pb-2">
            {[...Array(4)].map((_, index) => (
              <div
                key={index}
                className="flex-shrink-0 px-6 py-4 rounded-lg bg-[#F1F5FF] flex items-center gap-3 relative overflow-hidden"
              >
                {/* Wave effect overlay */}
                <div
                  className="absolute inset-0 -translate-x-full animate-[wave_1.5s_ease-in-out_infinite]"
                  style={{
                    animationDelay: `${index * 0.2}s`,
                    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)'
                  }}
                ></div>
                
                <div className="w-12 h-12 rounded-lg bg-blue-200"></div>
                <div className="h-4 bg-blue-100 rounded w-20"></div>
                <div className="w-4 h-4 rounded bg-blue-100 ml-2"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Sub Categories Section Skeleton */}
        <div className="mb-6">
          <div className="skeleton-shimmer h-10 w-36 rounded-lg bg-gray-200 mb-4"></div>
          
          <div className="overflow-x-auto">
            <table className="w-full border-separate border-spacing-y-2">
              {/* Table Header Skeleton */}
              <thead>
                <tr className="bg-blue-50 rounded-lg">
                  <th className="px-4 py-3 rounded-l-lg">
                    <div className="skeleton-shimmer h-4 w-16 rounded bg-gray-200"></div>
                  </th>
                  <th className="px-4 py-3">
                    <div className="skeleton-shimmer h-4 w-16 rounded bg-gray-200"></div>
                  </th>
                  <th className="px-4 py-3 rounded-r-lg">
                    <div className="skeleton-shimmer h-4 w-16 rounded bg-gray-200 ml-auto"></div>
                  </th>
                </tr>
              </thead>

              {/* Table Body Skeleton */}
              <tbody className="divide-y divide-transparent">
                {[...Array(5)].map((_, index) => (
                  <tr
                    key={index}
                    className="bg-gray-50 rounded-xl shadow-sm border border-gray-200"
                    style={{
                      animationDelay: `${index * 0.1}s`
                    }}
                  >
                    <td className="px-4 py-3 rounded-l-xl">
                      <div className="flex items-center gap-3">
                        <div className="skeleton-shimmer h-4 w-24 rounded bg-gray-200"></div>
                        <div className="skeleton-shimmer h-4 w-12 rounded-full bg-gray-200"></div>
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <div className="skeleton-shimmer w-10 h-10 rounded bg-gray-200"></div>
                    </td>
                    <td className="px-4 py-3 rounded-r-xl">
                      <div className="skeleton-shimmer w-5 h-5 rounded bg-gray-200 ml-auto"></div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
const Categories = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showSubCategoryModal, setShowSubCategoryModal] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [editingSubCategory, setEditingSubCategory] = useState(null);
  const [menuIndex, setMenuIndex] = useState(null);
  const scrollContainerRef = useRef(null);
  const dropdownRef = useRef(null);

  const {
    topCategories,
    subCategories,
    loading,
    error,
    addTopCategory,
    addSubCategory,
    updateTopCategory,
    updateSubCategory,
    deleteTopCategory,
    deleteSubCategory,
    toggleSubCategoryVisibility,
    refetch
  } = useCategories();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !event.target.closest('button')) {
        setMenuIndex(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // FIXED: Proper filtering function to match sub-categories with selected category
  const filteredSubCategories = selectedCategory
    ? subCategories.filter(subCategory => {
        const selectedCategoryId = selectedCategory._id;
        
        // Check all possible ways the category ID might be stored in sub-category
        // 1. Direct MongoDB ObjectId object
        if (subCategory.topCategory && subCategory.topCategory.$oid) {
          return subCategory.topCategory.$oid === selectedCategoryId;
        }
        
        // 2. Direct string ID
        if (subCategory.topCategory && typeof subCategory.topCategory === 'string') {
          return subCategory.topCategory === selectedCategoryId;
        }
        
        // 3. As an object with _id field
        if (subCategory.topCategory && subCategory.topCategory._id) {
          return subCategory.topCategory._id === selectedCategoryId;
        }
        
        // 4. Check other possible field names
        if (subCategory.categoryId && typeof subCategory.categoryId === 'string') {
          return subCategory.categoryId === selectedCategoryId;
        }
        
        if (subCategory.categoryId && subCategory.categoryId.$oid) {
          return subCategory.categoryId.$oid === selectedCategoryId;
        }
        
        if (subCategory.parentCategoryId && typeof subCategory.parentCategoryId === 'string') {
          return subCategory.parentCategoryId === selectedCategoryId;
        }
        
        if (subCategory.topCategoryId && typeof subCategory.topCategoryId === 'string') {
          return subCategory.topCategoryId === selectedCategoryId;
        }
        
        // If subCategory has a populated topCategory object
        if (subCategory.topCategory && subCategory.topCategory._id === selectedCategoryId) {
          return true;
        }
        
        return false;
      })
    : subCategories; // Show ALL sub-categories when no category is selected

  // Get selected category name for display
  const selectedCategoryName = selectedCategory?.name || null;

  const handleCategorySelect = (category) => {
    // Toggle selection - if same category clicked, deselect it
    if (selectedCategory && selectedCategory._id === category._id) {
      setSelectedCategory(null);
    } else {
      setSelectedCategory(category);
    }
  };

  const handleClearFilter = () => {
    setSelectedCategory(null);
  };

  // Helper function to get parent category for a sub-category
  const getParentCategory = (subCategory) => {
    if (!subCategory || !topCategories.length) return null;
    
    const subCategoryId = subCategory.topCategory;
    
    // If subCategoryId is an object with $oid (MongoDB ObjectId)
    if (subCategoryId && subCategoryId.$oid) {
      return topCategories.find(cat => cat._id === subCategoryId.$oid);
    }
    
    // If subCategoryId is a string
    if (subCategoryId && typeof subCategoryId === 'string') {
      return topCategories.find(cat => cat._id === subCategoryId);
    }
    
    // If subCategory has populated topCategory object
    if (subCategory.topCategory && subCategory.topCategory._id) {
      return topCategories.find(cat => cat._id === subCategory.topCategory._id);
    }
    
    // Check other possible fields
    if (subCategory.categoryId) {
      const categoryId = subCategory.categoryId.$oid || subCategory.categoryId;
      return topCategories.find(cat => cat._id === categoryId);
    }
    
    return null;
  };

  const handleCategoryEdit = (category) => {
    setEditingCategory(category);
    setShowCategoryModal(true);
    setMenuIndex(null);
  };

  const handleSubCategoryEdit = (subCategory) => {
    setEditingSubCategory(subCategory);
    setShowSubCategoryModal(true);
    setMenuIndex(null);
  };

  const handleDeleteCategory = (id) => {
    if (window.confirm('Are you sure you want to delete this category?')) {
      deleteTopCategory(id);
      setMenuIndex(null);
      // Clear selection if deleted category was selected
      if (selectedCategory && selectedCategory._id === id) {
        setSelectedCategory(null);
      }
    }
  };

  const handleDeleteSubCategory = (id) => {
    if (window.confirm('Are you sure you want to delete this sub-category?')) {
      deleteSubCategory(id);
      setMenuIndex(null);
    }
  };

  const handleView = (subCategory) => {
    console.log('Viewing:', subCategory);
    setMenuIndex(null);
    // Implement view logic here
  };

  const handleToggleVisibility = (id) => {
    toggleSubCategoryVisibility(id);
    setMenuIndex(null);
  };

  if (error) {
    return (
      <div className="text-center py-16">
        <div className="text-red-600 mb-4">
          <h3 className="text-lg font-semibold">Error loading categories</h3>
          <p className="text-sm">{error}</p>
        </div>
        <button 
          onClick={refetch} 
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div>
      <div>
        {/* Header */}
        <div className="mb-6">
          <div className="flex flex-row items-center justify-between gap-4">
            <h1 className="text-2xl font-bold text-gray-900">Categories</h1>
            <div className="flex gap-3 flex-wrap">
              <button
                onClick={() => {
                  setEditingCategory(null);
                  setShowCategoryModal(true);
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 
                         transition-colors flex items-center gap-2 text-sm md:text-base"
              >
                <CirclePlus size={18} />
                <span className='md:hidden'>Top</span>
                <span className='hidden md:block'>Top Categories</span>
              </button>
              <button
                onClick={() => {
                  setEditingSubCategory(null);
                  setShowSubCategoryModal(true);
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 
                         transition-colors flex items-center gap-2 text-sm md:text-base"
              >
                <CirclePlus size={18} />
                <span className='md:hidden'>Sub</span>
                <span className='hidden md:block'>Sub Categories</span>
              </button>
            </div>
          </div>
        </div>
        
        {loading ? <CategoriesSkeleton /> : <>
          {/* Top Categories Section */}
          <div className="mb-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 border border-blue-200 bg-white rounded-lg px-4 py-2 inline-block">
                Top Categories ({topCategories.length})
              </h2>
            </div>

            {/* Horizontal Scrollable Categories */}
            <div className="relative">
              <div
                ref={scrollContainerRef}
                className="flex gap-8 overflow-x-auto scrollbar-hide pb-2"
                style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
              >
                {topCategories.map((category, index) => (
                  <div
                    key={category._id}
                    onClick={() => handleCategorySelect(category)}
                    className={`flex-shrink-0 px-6 py-4 rounded-lg shadow-md cursor-pointer transition-all relative group flex items-center gap-3
                            ${selectedCategory && selectedCategory._id === category._id
                              ? 'bg-red-50 border-2 border-blue-400' 
                              : 'bg-[#F1F5FF] border-2 border-transparent hover:bg-blue-100'}`}
                  >
                    {/* Image */}
                    <div className="relative">
                      <img
                        src={category.image}
                        alt={category.name}
                        className={`w-12 h-12 object-cover rounded-lg shadow-lg transition-opacity ${category.hidden ? 'opacity-50' : ''}`}
                      />
                      {category.hidden && (
                        <div className="absolute inset-0 flex items-center justify-center bg-white/50 rounded-lg">
                          <EyeOff className="w-5 h-5 text-gray-600" />
                        </div>
                      )}
                    </div>
                    
                    {/* Name */}
                    <span className={`text-sm font-medium pr-2 ${category.hidden ? 'opacity-50' : ''}`}>
                      {category.name}
                    </span>

                    {/* Dropdown Menu Button */}
                    <div className="ml-auto">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          const button = e.currentTarget;
                          const buttonRect = button.getBoundingClientRect();
                          
                          setMenuIndex(menuIndex === `cat-${index}` ? null : {
                            index: `cat-${index}`,
                            position: {
                              top: buttonRect.bottom + window.scrollY,
                              left: buttonRect.left,
                              direction: window.innerHeight - buttonRect.bottom > 150 ? 'below' : 'above'
                            }
                          });
                        }}
                        className={`p-1 rounded transition-colors ${
                          selectedCategory && selectedCategory._id === category._id
                            ? 'hover:bg-blue-400' 
                            : 'hover:bg-blue-200 text-gray-600'
                        }`}
                      >
                        <MoreHorizontal className="w-4 h-4" />
                      </button>

                      {/* Dropdown Menu */}
                      {menuIndex?.index === `cat-${index}` && (
                        <div
                          ref={dropdownRef}
                          className="fixed z-50 w-40 bg-white shadow-lg rounded-lg border border-gray-200 py-1"
                          style={{
                            top: menuIndex.position.direction === 'below'
                              ? `${menuIndex.position.top + 5}px`
                              : `${menuIndex.position.top - 100}px`,
                            left: `${menuIndex.position.left - 120}px`
                          }}
                        >
                          <button
                            onClick={() => handleCategoryEdit(category)}
                            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                          >
                            <Edit2 size={16} /> Edit
                          </button>
                          <div className="border-t border-gray-100 my-1"></div>
                          <button
                            onClick={() => handleDeleteCategory(category._id)}
                            className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
                          >
                            <Trash2 size={16} /> Delete
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Sub Categories Section */}
          <div className="mb-6">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-semibold text-gray-900 border border-blue-200 bg-white rounded-lg px-4 py-2 inline-block">
                Sub Categories ({filteredSubCategories.length})
                {selectedCategoryName && (
                  <span className="text-sm font-normal text-blue-600 ml-2">
                    - {selectedCategoryName}
                  </span>
                )}
              </h2>
              
              {/* Clear Filter Button */}
              {selectedCategory && (
                <button
                  onClick={handleClearFilter}
                  className="px-3 py-2 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg flex items-center gap-2 transition-colors"
                >
                  <X size={16} />
                  Show All ({subCategories.length})
                </button>
              )}
            </div>
            
            <div className="overflow-x-auto">
              <table className="w-full border-separate border-spacing-y-2 shadow rounded">
                <thead>
                  <tr className="bg-blue-50 text-left rounded-lg">
                    <th className="px-4 py-3 text-sm font-medium text-gray-700 rounded-l-lg">Name</th>
                    <th className="px-4 py-3 text-sm font-medium text-gray-700">Image</th>
                    <th className="px-4 py-3 text-sm font-medium text-gray-700 text-center">Category</th>
                    <th className="px-4 py-3 text-sm font-medium text-gray-700 text-right rounded-r-lg">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-transparent">
                  {filteredSubCategories.map((subCategory, index) => {
                    const parentCategory = getParentCategory(subCategory);
                    
                    return (
                      <tr key={subCategory._id} className="bg-gray-50 rounded-xl shadow-sm border border-gray-200 hover:bg-gray-100 transition-colors">
                        <td className="px-4 py-3 rounded-l-xl">
                          <div className="flex items-center gap-3">
                            <span className="text-sm font-medium text-gray-900">{subCategory.name}</span>
                            {subCategory.status === 'deleted' && (
                              <span className="px-2 py-1 bg-red-100 text-red-600 text-xs rounded-full">
                                Deleted
                              </span>
                            )}
                            {subCategory.hidden && (
                              <EyeOff className="w-4 h-4 text-gray-400" />
                            )}
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex">
                            <img
                              src={subCategory.image}
                              alt={subCategory.name}
                              className="w-10 h-10 object-cover rounded"
                            />
                          </div>
                        </td>
                        <td className="px-4 py-3 whitespace-nowrap text-center">
                          <span className="text-xs px-2 py-1 bg-blue-100 text-blue-800 rounded-full">
                            {parentCategory?.name || 'Unknown'}
                          </span>
                        </td>
                        <td className="px-4 py-3 rounded-r-xl">
                          <div className="flex items-center justify-end">
                            <div className="relative">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const button = e.currentTarget;
                                  const buttonRect = button.getBoundingClientRect();
                                  
                                  setMenuIndex(menuIndex === `sub-${index}` ? null : {
                                    index: `sub-${index}`,
                                    position: {
                                      top: buttonRect.bottom + window.scrollY,
                                      left: buttonRect.right - 144,
                                      direction: window.innerHeight - buttonRect.bottom > 200 ? 'below' : 'above'
                                    }
                                  });
                                }}
                                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                              >
                                <MoreHorizontal className="w-5 h-5 text-gray-500" />
                              </button>

                              {menuIndex?.index === `sub-${index}` && (
                                <div
                                  ref={dropdownRef}
                                  className="fixed z-50 w-40 bg-white shadow-lg rounded-lg border border-gray-200 py-1"
                                  style={{
                                    top: menuIndex.position.direction === 'below'
                                      ? `${menuIndex.position.top + 5}px`
                                      : `${menuIndex.position.top - 165}px`,
                                    left: `${menuIndex.position.left}px`
                                  }}
                                >
                                  <button
                                    onClick={() => handleView(subCategory)}
                                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                                  >
                                    <Eye size={16} /> View
                                  </button>
                                  <button
                                    onClick={() => handleSubCategoryEdit(subCategory)}
                                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                                  >
                                    <Edit2 size={16} /> Edit
                                  </button>
                                  <button
                                    onClick={() => handleToggleVisibility(subCategory._id)}
                                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                                  >
                                    <EyeOff size={16} /> {subCategory.hidden ? 'Show' : 'Hide'}
                                  </button>
                                  <div className="border-t border-gray-100 my-1"></div>
                                  <button
                                    onClick={() => handleDeleteSubCategory(subCategory._id)}
                                    className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
                                  >
                                    <Trash2 size={16} /> Delete
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              
              {/* No Data Message */}
              {filteredSubCategories.length === 0 && (
                <div className="flex flex-col items-center justify-center py-16 px-4">
                  {/* Icon Container */}
                  <div className="relative mb-6">
                    <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center">
                      <Layers2 className="w-12 h-12 text-gray-400" />
                    </div>
                    {/* Decorative dots */}
                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-blue-100 rounded-full"></div>
                    <div className="absolute -bottom-1 -left-1 w-4 h-4 bg-blue-200 rounded-full"></div>
                    <div className="absolute top-8 -right-6 w-3 h-3 bg-gray-200 rounded-full"></div>
                  </div>

                  {/* Message */}
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {selectedCategory ? 'No Sub-Categories in this Category' : 'No Sub-Categories Yet'}
                  </h3>
                  <p className="text-sm text-gray-500 text-center max-w-md mb-6">
                    {selectedCategory 
                      ? `No sub-categories found for "${selectedCategory.name}". Add some to organize your products better.`
                      : "Start by adding sub-categories to organize your products better."}
                  </p>

                  {/* Action Buttons */}
                  <div className="flex gap-3">
                    {selectedCategory && (
                      <button
                        onClick={handleClearFilter}
                        className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 
                                transition-colors flex items-center gap-2 text-sm"
                      >
                        <Eye className="w-4 h-4" />
                        Show All Sub-Categories
                      </button>
                    )}
                    <button
                      onClick={() => {
                        setEditingSubCategory(null);
                        setShowSubCategoryModal(true);
                      }}
                      className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 
                              transition-colors flex items-center gap-2 text-sm"
                    >
                      <CirclePlus className="w-4 h-4" />
                      {selectedCategory ? 'Add Sub-Category' : 'Add First Sub-Category'}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>}

        {/* Modals */}
        <CategoryModal
          isOpen={showCategoryModal}
          onClose={() => {
            setShowCategoryModal(false);
            setEditingCategory(null);
          }}
          onSubmit={(data) => {
            if (editingCategory) {
              updateTopCategory(editingCategory._id, data);
            } else {
              addTopCategory(data);
            }
            setShowCategoryModal(false);
            setEditingCategory(null);
          }}
          editingCategory={editingCategory}
        />

        <SubCategoryModal
          isOpen={showSubCategoryModal}
          onClose={() => {
            setShowSubCategoryModal(false);
            setEditingSubCategory(null);
          }}
          onSubmit={(data) => {
            if (editingSubCategory) {
              updateSubCategory(editingSubCategory._id, data);
            } else {
              addSubCategory(data);
            }
            setShowSubCategoryModal(false);
            setEditingSubCategory(null);
          }}
          editingSubCategory={editingSubCategory}
          topCategories={topCategories}
        />
      </div>
    </div>
  );
};

export default Categories;